import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import BackOfficeLayout from "../../../components/backoffice-layout";
import InputSearchComponent from "../../../components/input-search";
import ButtonComponent from "../../../components/button";
import PaginatorComponent from "../../../components/paginator";
import IconPlus from "../../../assets/images/icon-plus-1.svg"
import { useNavigate } from "react-router-dom";
import CoreAPI from "../../../services/core";
import LoadingModal from "../../../components/loading-modal";
import DeleteModal from "../../../components/modal/delete";
import SuccessModal from "../../../components/modal/success";
import DropdownFilterComponent from "../../../components/evaluation-form-components/dropdown-filter";
import TableLocationComponent from "../../../components/table-location";
import InfoModal from "../../../components/modal/info";
import LocationInfoModal from "../../../components/modal/location-info";
import LocationCreateModal from "../../../components/modal/location-create";

const Container = styled.div`
    width: calc(100% - 32px);
    background-color: #FFFFFF;
    padding: 40px 16px;
    border-radius: 16px;

    .header-box {
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;

        .header-label {
            width: fit-content;
            color: #25368D;
            font-size: 20px;
            font-weight: 600;
            line-height: 29.9px;
            text-align: left;
            padding: 2px;
            border-width: 0px 0px 3px 0px;
            border-style: solid;
            border-color: #25368D;
        }
    }


    .filter-bar {
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-bottom: 36px;

        .multi-box {
            display: flex;
            gap: 24px;

            .multi-select {
                width: calc(100% - 162px);
                display: flex;
                gap: 16px;

                .line {
                    width: 1px;
                    height: calc(100% - 16px);
                    margin-top: 20px;
                    background-color: #F2F2F2;
                }
            }
        }
    }

    .data-box {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }
`;


function LocationManagementPage() {
    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [pageOption, setPageOption] = useState({
        limit: 10,
        page: 1,
        total_item: 0,
        total_page: 1,
    });
    const [orderOption, setOrderOption] = useState({
        order: "DESC",
        orderBy: "location_name",
    });
    const [isLoading, setIsLoading] = useState(false);
    const [listData, setListData] = useState([]);
    const [dataFocus, setDataFocus] = useState(null);
    const [detailModal, setDetailModal] = useState({
        title: "",
        sub_title: "",
    });
    const [openModal, setOpenModal] = useState(false);
    const [openInfoModal, setOpenInfoModal] = useState(false);
    const [openLocationInfoModal, setOpenLocationInfoModal] = useState(false);
    const [openLocationCreateModal, setOpenLocationCreateModal] = useState(false);
    const [detailSuccessModal, setDetailSuccessModal] = useState({
        title: "ลบสมาชิกสำเร็จ",
        sub_title: "",
        type: "success",
        button_label: "กลับหน้าหลัก",
    });
    const [openSuccessModal, setOpenSuccessModal] = useState(false);
    const [listProvince, setlistProvince] = useState([]);
    const [listProvinceSelect, setlistProvinceSelect] = useState([]);

    useEffect(() => {
        onInit();
    }, [])

    async function onInit() {
        setIsLoading(true);
        let _profile = localStorage.getItem("profile");
        try {
            _profile = JSON.parse(_profile)
        } catch { }
        if (_profile?.user_username !== "superadmin" && _profile?.user_username !== "admin") {
            navigate(`/account`);
            return
        }
        onGetProvince();
        await onGetData(
            search,
            pageOption.limit,
            pageOption.page,
            orderOption.order,
            orderOption.orderBy,
            listProvinceSelect.map(x => x.label),
        );
        setIsLoading(false);
    }
    async function onGetData(search, limit, page, order, order_by, province) {
        let response = null;
        try {
            const body = {
                search: search,
                search_by: ["location_name"],
                order: order || "ASC",
                order_by: order_by,
                limit: limit,
                page: page,
                province: [...province],
            };
            response = await CoreAPI.locationHttpService.locationGetListByParam(body)
        } catch { }
        if (response) {
            let detailPage = { ...pageOption }
            detailPage.limit = response.limit;
            detailPage.page = response.page;
            detailPage.total_item = response.total_item;
            detailPage.total_page = response.total_page;
            setPageOption(detailPage);
            setListData(response.data)
        }
        return response;
    }
    async function onGetProvince() {
        let response = [];
        try {
            response = await CoreAPI.locationHttpService.locationProvince()
        } catch { }
        if (Array.isArray(response)) {
            response = response.map(x => {
                return {
                    id: x.location_province,
                    label: x.location_province,
                }
            })
        }
        setlistProvince(response)
        setlistProvinceSelect(JSON.parse(JSON.stringify(response)))
        return response;
    }
    async function onCreateData(param) {
        let response = null;
        try {
            const body = {
                location_name: param.location_name,
                province: param.province,
                latitude: param.latitude,
                longitude: param.longitude,
            };
            response = await CoreAPI.locationHttpService.locationCreate(body)
        } catch { }
        let detail = {
            title: "สร้างสถานที่ล้มเหลว",
            sub_title: "",
            type: "fail",
            button_label: "กลับหน้าหลัก",
        }
        if (response) {
            if (response.success === true) {
                detail = {
                    title: "สร้างสถานที่สำเร็จ",
                    sub_title: "",
                    type: "success",
                    button_label: "กลับหน้าหลัก",
                }
            }
        }
        setOpenSuccessModal(true)
        setDetailSuccessModal(detail)
        return detail;
    }
    async function onUpdateData(param) {
        let response = null;
        try {
            const body = {
                location_id: param.location_id,
                location_name: param.location_name,
                province: param.province,
                latitude: param.latitude,
                longitude: param.longitude,
            };
            response = await CoreAPI.locationHttpService.locationUpdate(body)
        } catch { }
        let detail = {
            title: "แก้ไขสถานที่ล้มเหลว",
            sub_title: "",
            type: "fail",
            button_label: "กลับหน้าหลัก",
        }
        if (response) {
            if (response.success === true) {
                detail = {
                    title: "แก้ไขสถานที่สำเร็จ",
                    sub_title: "",
                    type: "success",
                    button_label: "กลับหน้าหลัก",
                }
            }
        }
        setOpenSuccessModal(true)
        setDetailSuccessModal(detail)
        return detail;
    }
    async function onDeleteData(id) {
        let response = null;
        try {
            response = await CoreAPI.locationHttpService.locationRemove(id)
        } catch { }
        let detail = {
            title: "ลบสถานที่ล้มเหลว",
            sub_title: "",
            type: "fail",
            button_label: "กลับหน้าหลัก",
        }
        if (response) {
            if (response.success === true) {
                detail = {
                    title: "ลบสถานที่สำเร็จ",
                    sub_title: "",
                    type: "success",
                    button_label: "กลับหน้าหลัก",
                }
            }
        }
        setOpenSuccessModal(true)
        setDetailSuccessModal(detail)
    }

    async function handleInputSearch(param) {
        setSearch(param)
    }
    async function handleEnterSearch() {
        setIsLoading(true);
        await onGetData(
            search,
            pageOption.limit,
            1,
            orderOption.order,
            orderOption.orderBy,
            listProvinceSelect.map(x => x.label),
        );
        setIsLoading(false);
    }
    async function handleChangePageOption(param) {
        setIsLoading(true);
        await onGetData(
            search,
            param.limit,
            param.page,
            orderOption.order,
            orderOption.orderBy,
            listProvinceSelect.map(x => x.label),
        );
        setIsLoading(false);
    }
    async function handleChangeOrderOption(param) {
        setIsLoading(true);
        setOrderOption(param)
        await onGetData(
            search,
            pageOption.limit,
            pageOption.page,
            param.order,
            param.orderBy,
            listProvinceSelect.map(x => x.label),
        );
        setIsLoading(false);
    }
    function handleCreate() {
        setDataFocus(null);
        setOpenLocationCreateModal(true);
    }
    async function handleConfirmLocationCreate(param) {
        let detail = { ...param }
        setIsLoading(true);
        let response_ = null;
        if (detail.location_id) {
            response_ = await onUpdateData(detail)
        } else {
            response_ = await onCreateData(detail)
        }
        if (response_?.type === "fail") {
            setIsLoading(false);
            return;
        }
        const response = await onGetData(
            search,
            pageOption.limit,
            pageOption.page,
            orderOption.order,
            orderOption.orderBy,
            listProvinceSelect.map(x => x.label),
        );
        if (response) {
            if (response.page !== 1 && response.data.length === 0) {
                await onGetData(
                    search,
                    pageOption.limit,
                    pageOption.page,
                    orderOption.order,
                    orderOption.orderBy,
                    listProvinceSelect.map(x => x.label),
                );
            }
        }
        setOpenLocationCreateModal(false)
        setIsLoading(false);
        setDataFocus(null);
    }
    function handleUpdate(param) {
        setDataFocus(param);
        setOpenLocationCreateModal(true);
    }
    function handleDelete(param) {
        let detail = { ...detailModal };
        detail.title = "ยืนยันการลบสถานที่"
        detail.sub_title = param?.location_name
        if (Array.isArray(param.ef_data) && param.ef_data.length > 0) {
            detail.title = "ไม่สามารถลบได้เนื่องจาก สถานที่ กำลังถูกใช้งาน"
            setDetailModal(detail)
            setOpenInfoModal(true)
        } else {
            setDetailModal(detail)
            setOpenModal(true)
        }
        setDataFocus(param)
    }
    function handleOpenList(param) {
        setDataFocus(param)
        setOpenLocationInfoModal(true)
    }
    async function handleConfirmDelete() {
        let detail = { ...dataFocus }
        setOpenModal(false)
        setIsLoading(true);
        await onDeleteData(detail.id)
        const response = await onGetData(
            search,
            pageOption.limit,
            pageOption.page,
            orderOption.order,
            orderOption.orderBy,
            listProvinceSelect.map(x => x.label),
        );
        if (response) {
            if (response.page !== 1 && response.data.length === 0) {
                await onGetData(
                    search,
                    pageOption.limit,
                    pageOption.page,
                    orderOption.order,
                    orderOption.orderBy,
                    listProvinceSelect.map(x => x.label),
                );
            }
        }
        setIsLoading(false);
        setDataFocus(null);
    }

    return (
        <BackOfficeLayout>
            <LoadingModal open={isLoading} />
            <DeleteModal
                open={openModal}
                onConfirm={handleConfirmDelete}
                onBack={(e) => setOpenModal(false)}
                title={detailModal.title}
                subTitle={detailModal.sub_title}
            />
            <InfoModal
                open={openInfoModal}
                onBack={(e) => setOpenInfoModal(false)}
                title={detailModal.title}
                subTitle={detailModal.sub_title}
            />
            <SuccessModal
                open={openSuccessModal}
                onConfirm={(e) => setOpenSuccessModal(false)}
                title={detailSuccessModal.title}
                type={detailSuccessModal.type}
                buttonLabel={detailSuccessModal.button_label}
            />
            <LocationInfoModal
                open={openLocationInfoModal}
                onBack={(e) => setOpenLocationInfoModal(false)}
                data={dataFocus}
            />
            <LocationCreateModal
                open={openLocationCreateModal}
                onConfirm={handleConfirmLocationCreate}
                onClose={(e) => setOpenLocationCreateModal(false)}
                detailData={dataFocus}
                listProvince={listProvince}
            />
            <Container>
                <div className="header-box vertical-center">
                    <div className="header-label">
                        ประวัติการสร้างสถานที่ {pageOption.total_item !== 0 ? `(${pageOption.total_item})` : ""}
                    </div>
                    <ButtonComponent
                        label={"สร้างสถานที่"}
                        variant={"primary"}
                        icon={IconPlus}
                        sceenSize={"lg"}
                        style={{ width: "200px", maxWidth: "200px", minWidth: "200px" }}
                        onClick={handleCreate}
                    />
                </div>
                <div className="filter-bar">
                    <InputSearchComponent
                        styleInput={{ height: "56px" }}
                        placeholder={"ค้นหา"}
                        onEnter={handleEnterSearch}
                        onInput={handleInputSearch}
                    />
                    <div className="multi-box">
                        <div className="multi-select">
                            <DropdownFilterComponent
                                label={"จังหวัด"}
                                placeholder={"เลือกจังหวัด"}
                                list={listProvince}
                                value={listProvinceSelect}
                                mode={"multi"}
                                onSelect={(e) => setlistProvinceSelect(e)}
                            />
                        </div>
                        <div className="vertical-center" style={{ paddingTop: "20px" }}>
                            <ButtonComponent
                                label={"ค้นหา"}
                                variant={"secondary"}
                                sceenSize={"lg"}
                                style={{ width: "156px", maxWidth: "156px", minWidth: "156px" }}
                                onClick={handleEnterSearch}
                            />
                        </div>
                    </div>
                </div>
                <div className="data-box">
                    <TableLocationComponent
                        listData={listData}
                        order={orderOption}
                        onOrder={handleChangeOrderOption}
                        onDelete={handleDelete}
                        onUpdate={handleUpdate}
                        onOpenList={handleOpenList}
                    />
                    <PaginatorComponent
                        limit={pageOption.limit}
                        page={pageOption.page}
                        total_item={pageOption.total_item}
                        total_page={pageOption.total_page}
                        onChangePageOption={handleChangePageOption}
                    />
                </div>
            </Container>
        </BackOfficeLayout>
    )
}

export default LocationManagementPage;